import { Aquisicao } from '../../../../cliente-carteira/kpis/aquisicao/adapters';
import { CarteiraInativa } from '../../../../cliente-carteira/kpis/carteira-inativa/adapters';
import { Comissao } from '../../../../comissao/kpis/adapters';

/** Dados dos KPIs mensal */
export class Mes {
    mes: number;
    aquisicao: Aquisicao;
    carteiraInativa: CarteiraInativa;
    comissao: Comissao;

    constructor(props: Partial<Mes>) {
        Object.assign(this, props);

        if (props) {
            // Aquisição
            this.aquisicao = props.aquisicao ? new Aquisicao(props.aquisicao) : null;
            // Carteira Inativa
            this.carteiraInativa = props.carteiraInativa ? new CarteiraInativa(props.carteiraInativa) : null;
            // Comissão
            this.comissao = props.comissao ? new Comissao(props.comissao) : null;
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Mes {
        return new Mes(JSON.parse(json));
    }
}
